import ColorPickerIcon from './styled'

export default ColorPickerIcon
